import {
    GET_PAYMENT_METHOD_DEF_SUCCESS,
    API_ERROR
  } from "./actionTypes"
  
  const INIT_STATE = {
    recordList: [], //Model Data ve Error
    error: {},
  }
  
  const paymentMethod = (state = INIT_STATE, action) => {
    switch (action.type) {
  
      case GET_PAYMENT_METHOD_DEF_SUCCESS:
        return {
          ...state,
          recordList: action.payload,
        }
      case API_ERROR:
        return {
          ...state,
          error: action.payload,
          loading: false 
        }
  
      default:
        return state
  
    }
  }
  
  export default paymentMethod